export enum USER_SCOPE {
  CUSTOMER = 'customer',
  OPERATION_PORTAL = 'portal_user',
}
